import type { ExerciseRun } from '@/api/exercises'

/** Попытка закрыта: ответы больше не принимаются. */
export const isRunDone = (run: ExerciseRun): boolean => run.status !== 'active'

/** Зачётная работа: тренировку ученик запускает сам, и оценкой она не является. */
export const isGradedRun = (run: ExerciseRun): boolean => run.mode !== 'training'
